import React, { useState } from "react";
import './NewHeader.css';
import { Space, Table} from 'antd';
import { useAuth } from "./AuthContext";
import { Link } from "react-router-dom";

export const NewHeader = () => {
  const {user} = useAuth();
  const username = user.user;

  const [isIsFormOpenFor_Notifications, setIsFormOpenFor_Notifications] = useState(false);
  const [isSelectedItem, setSelectedItem] = useState(false);  

  const openForm1 = () => {
    setIsFormOpenFor_Notifications(true);
    setSelectedItem(true);
  };

  const closeForm1 = () => {
    setIsFormOpenFor_Notifications(false);
    setSelectedItem(false);
  };

  const SelectedItemStyle = {
    backgroundColor: isSelectedItem ? '#bcc5cf' : 'transparent',
    borderRadius:'5vw',
  };

  const ColumnsOf_Notifications = [
    {
      title: 'img',
      dataIndex: 'img',
      key: 'img',
      width:'15%',
      render: (_, record) => (
        <Space size="">
          <div className="notification_dot"></div>
          <img className='profile_pic_NewHeader' src="../assets/Profile.png" alt="profile pic" height={"40px"}></img>   
        </Space>
      ),
    },
    {
      title: 'NotificationContent',
      dataIndex: 'NotificationContent',
      key: 'NotificationContent',
    },
    {
      title: 'date',
      dataIndex: 'date',
      key: 'date',
      width:'8vw',
    },
  ];
  const dataOf_Notifications = [
    {
      key: '1',
      NotificationContent:'$NotificationContent',
      date:'20/02/2002',
    },
    {
      key: '1',
      NotificationContent:'$NotificationContent',
      date:'20/02/2002',
    },
    {
      key: '1',
      NotificationContent:'$NotificationContent',
      date:'20/02/2002',
    },
    {
      key: '1',
      NotificationContent:'$NotificationContent',
      date:'20/02/2002',
    },
    {
      key: '1',
      NotificationContent:'$NotificationContent',
      date:'20/02/2002',
    },

    
  ];

    return(
        <div className='header1'>
        <div className="column1_header1">
          <p className='hello_header1'><b>Hello, {username.username}</b></p>
          <p className='niceDay_header1'>Have a nice day!</p>
        </div>
  
        <div className="column2_header1">
          <p className='name_header1'><b>{username.username}</b></p>
          <p className='role1'>{username.role}</p>            
        </div>

        <div className="column3_header1">
          <Link to="/SettingsPage"><img className='profilePic_header1' src="../assets/Profile.png" alt="." ></img>  </Link> 
        </div>

        <div className="column4_header1">
          <img className='line_header1' src="../assets/line.png" alt="line"></img>
        </div>

        <div className="column5_header1">
          <img className='bell_header1' src="../assets/bell.png" alt="bell" style={SelectedItemStyle} onClick={isSelectedItem ? null : openForm1}></img>
        </div>
        {isIsFormOpenFor_Notifications && (
              <>
              <div className="overlay_header1" onClick={closeForm1}></div>
                <div className="popup-form_header1">
                  <span className="close_header1" onClick={closeForm1}>&times;</span>
                  <p className="notification_header1"><b>Notifications</b></p><br/>
                    {/* Your form content goes here */}
                      <form>
                      {/* Form fields go here */}
                        <div>
                          <Table 
                            columns={ColumnsOf_Notifications} 
                            dataSource={dataOf_Notifications} 
                            scroll={{ y: 300 }}
                            pagination={false}
                            showHeader={false}
                          />
                        </div>      
                      </form>
                </div>
              </>
            )}

        <div className="column6_header1">
          <img className='location_header1' src="../assets/location.png" alt="location"></img>  
        </div>  
      </div>
    )
}
